import React, { useEffect, useState } from 'react';
import { useAccountClosure } from './accountClosureContext';
import LifecycleRecoveryView from './LifecycleRecoveryView';
import { ApplicationButton } from '../../components/application';

export default function AccountClosurePage() {
  const closure = useAccountClosure();
  const [ready, setReady] = useState(false);
  useEffect(() => { let active = true;
    closure.refresh().then(mode => { if (active) setReady(mode === 'lifecycle'); });
    return () => { active = false; };
  // Read mode once on entry; no polling or automatic initiation.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return <main className="auth-page account-closure-page">
    <section aria-label="Account closure" className="auth-card auth-card--wide account-closure-card">
      {ready ? <LifecycleRecoveryView client={closure.getClient()} initialState={closure.status} /> : <>
        <h1>Account-closure status</h1>
        <p role="status">Status access is currently unavailable. This does not cancel an existing closure request or restore account access. Recovery information has not been removed.</p>
        <ApplicationButton onClick={async () => setReady(await closure.refresh() === 'lifecycle')}>Retry</ApplicationButton>
      </>}
    </section>
  </main>;
}
